import { render, staticRenderFns } from "./personalData.vue?vue&type=template&id=c2995eb8&scoped=true"
import script from "./personalData.vue?vue&type=script&lang=js"
export * from "./personalData.vue?vue&type=script&lang=js"
import style0 from "./personalData.vue?vue&type=style&index=0&id=c2995eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2995eb8",
  null
  
)

export default component.exports